import api from './api';

export const deviceService = {
  // Pobierz wszystkie urządzenia
  getDevices: async (page = 1, limit = 10) => {
    const response = await api.get(`/devices?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Pobierz urządzenie po ID
  getDevice: async (id) => {
    const response = await api.get(`/devices/${id}`);
    return response.data;
  },

  // Dodaj nowe urządzenie
  addDevice: async (deviceData) => {
    const response = await api.post('/devices', deviceData);
    return response.data;
  },

  // Aktualizuj urządzenie
  updateDevice: async (id, deviceData) => {
    const response = await api.put(`/devices/${id}`, deviceData);
    return response.data;
  },

  // Usuń urządzenie
  deleteDevice: async (id) => {
    const response = await api.delete(`/devices/${id}`);
    return response.data;
  },

  // Sprawdź status urządzenia
  checkDeviceStatus: async (id) => {
    const response = await api.post(`/devices/${id}/check-status`);
    return response.data;
  },

  // Dodaj folder do urządzenia
  addFolder: async (deviceId, folderData) => {
    const response = await api.post(`/devices/${deviceId}/folders`, folderData);
    return response.data;
  },

  // Aktualizuj folder
  updateFolder: async (deviceId, folderId, folderData) => {
    const response = await api.put(`/devices/${deviceId}/folders/${folderId}`, folderData);
    return response.data;
  },

  // Usuń folder
  deleteFolder: async (deviceId, folderId) => {
    const response = await api.delete(`/devices/${deviceId}/folders/${folderId}`);
    return response.data;
  },

  // Pobierz statystyki typów urządzeń
  getDeviceStats: async () => {
    const response = await api.get('/devices/types/stats');
    return response.data;
  }
};
